import React, { useEffect, useContext }from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import Datetime from "react-datetime";

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";
import MenuItem from "@material-ui/core/MenuItem";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import moment from "moment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";

import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1, MaskDate, formateDate, validateDate, convertDate, getLocale, getStringFormatDate} from "beaktShared/helpers/masks";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Estabelecimento from "beaktDay/views/AdminAgenda/Outros/Estabelecimento";
const useStyles = makeStyles(styles);

export default function CreditoDebitoForm({ addItem, item, handleView }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    
    const { register, handleSubmit, setValue, errors, getValues, setError } = useForm({mode: "onChange"});
    
    const [loading, setloading] = React.useState(false);
    const [tipo, settipo] = React.useState("D");

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const [dataVencimento,setdataVencimento] = React.useState("");
    useEffect(() => {
        if(!item.creditoDebitoId)
            return;    
        setValue('id', item.creditoDebitoId);     
        setValue('tipo', item.tipo);     
        settipo(item.tipo);         
        var dtVenc = "";  
        if(item.dataVencimento!==null)
            dtVenc = formateDate(item.dataVencimento);        
                
        setdataVencimento(dtVenc);
        setValue("dataVencimento", dtVenc);   

        setValue('historico', item.historico); 
        let valor = transformValueFloattoFormated(item.valor);
        setValue("valor",valor);
        loadSelectEstabelecimentoView(item.estabelecimentoId);
        setisDisabledEstabelecimento(true);
    }, [item]);

    const loadSelectEstabelecimentoView = (estabelecimentoId) =>{        
        if(estabelecimentoId===null)
            return;

        let lstAdd = [];
        lstAdd.push(item.estabelecimentoId);                
        setestabelecimentos(lstAdd);     
        setValue('estabelecimentos', lstAdd);  
    }

    useEffect(()=>{
        setValue('tipo', "D")
        loadSelectEstabelecimentos();        
    },[]);

    const [isDisabledEstabelecimento, setisDisabledEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const loadSelectEstabelecimentos = () =>{   
        setloadingSelectEstabelecimentos(true);     
        const endPoint = "estabelecimentos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                //showNotification(result.message,'danger');  
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setloadingSelectEstabelecimentos(false); 
            setlistSelectEstabelecimentos(result.data);
            return true;                
        });  
    }
    const handleEstabelecimentoChange = event => {
        let value = event

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
           
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistEstabelecimentosSelected(lstSelect);
        setValue("estabelecimentos", lstsAdd); 
    };
    const handleClickSelecionarTodosEstabelecimentos = () =>{
        
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
           
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistEstabelecimentosSelected(lstSelect);
        setValue("estabelecimentos", lstsAdd); 
    }

    const onSubmit = data => {

        if (!validateDate(dataVencimento)) {
            setError("dataVencimento", "invaliddate", t('error_message.invalid_date'))
            return false;
        }

        let valor = transformValueFormatedtoFloat(data.valor);
        let dtvenc = convertDate(dataVencimento);
        let obj = {
            creditoDebitoId:parseInt(data.id),
            franquiaId:session.franquiaId,
            usuarioCadastroId:session.id,
            tipo:data.tipo,
            dataVencimento:dtvenc,
            historico:data.historico,
            valor:valor,
            origem:'M'
        };   
        
        let endPoint = "creditosDebitos/";
        if(obj.creditoDebitoId > 0)
        {
            obj = {
                ...obj,
                estabelecimentoId:item.estabelecimentoId
            }

            setloading(true);
            UsePutApi(endPoint,obj.creditoDebitoId,obj).then(result=>{
                if(result.status !== 200)
                {                                    
                    showNotification(result.message,'danger');
                    setloading(false);
                    return false; 
                }                     
                                
                setloading(false);
                addItem(t('information_message.updated_successfully'));         
            });             
        }
        else
        {    
            obj = {
                ...obj,
                qtdOcorrencias:data.qtdOcorrencias,
                estabelecimentoCreditoDebitos:listSelectEstabelecimentosSelected
            }
            setloading(true);
            UsePostApi(endPoint,obj).then(result=>{     
                if(result.status !== 200)
                {                                     
                    showNotification(result.message,'danger');
                    setloading(false);
                    return false; 
                }                 
                setloading(false);
                addItem(t('information_message.registered_successfully'));   
            });         
        }

    };

return (
    <div className="maxContent">             
        <form onSubmit={handleSubmit(onSubmit)}>
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <PermIdentity />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>
                            {t('royaltie.credit_and_debit_posting')}
                            <input className={classes.hidden} defaultValue={0} name="id" ref={register} />
                        </h4>
                    </CardHeader>
                    <CardBody>                            
                        <GridContainer>
                            
                            <GridItem xs={12} sm={3} md={3}> 
                                <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dataVencimento?"select__label select__label_error":"select__label"}>
                                    {t('label.due_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dataVencimento"                                      
                                    defaultValue={dataVencimento}
                                    value={dataVencimento}
                                    onChange={date => { setdataVencimento(date) }}
                                    inputProps={{name:"dataVencimento", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dataVencimento?"error":""}            
                                />       
                                {errors.dataVencimento && <FormHelperText className={classes.labelRootError}>
                                    <span> {t('label.required')} </span>                                                                          
                                </FormHelperText>} 
                                </FormControl>                                 
                            </GridItem>     
                            <GridItem xs={12} sm={2} md={2}>
                                <FormControl fullWidth className={classes.formControl}>   
                                <TextField
                                    fullWidth
                                    label={t('label.qty_occurrences')+" *"}
                                    variant="outlined"
                                    InputLabelProps={{shrink: true}} 
                                    name="qtdOcorrencias"                  
                                    defaultValue={1}      
                                    type="number"                                                 
                                    inputProps={{maxLength: 3}} 
                                    onInput={(e) => MaskOnlyNumbersStart1(e) }          
                                    inputRef={register({required: true})}
                                    error={errors.qtdOcorrencias?true:false} 
                                />                                
                                {errors.qtdOcorrencias &&
                                <FormHelperText> <span className="obg">{t('label.required')}</span>
                                </FormHelperText> }
                            </FormControl>    
                        </GridItem>                          
                            <GridItem xs={12} sm={3} md={4}>
                                <FormControl fullWidth className={classes.formControl}>   
                                <TextField
                                    label={t('sale.type')+" *"}
                                    fullWidth
                                    error={errors.tipo ? true : false}
                                    select
                                    variant="outlined"              
                                    value={tipo}
                                    onChange={(e)=> {settipo(e.target.value); setValue("tipo", e.target.value)}}
                                    name="tipo"              
                                    ref={() => register({ name: "tipo" }, { required: true  })}
                                    InputLabelProps={{ shrink: true }}
                                    >
                                    <MenuItem value="D"> {t('label.debit')} </MenuItem>
                                    <MenuItem value="C"> {t('label.credit')} </MenuItem>
                                    </TextField>
                                    {errors.tipo && <FormHelperText>
                                        <span className="obg">{t('label.required')}</span>
                                    </FormHelperText>}
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={4} md={3}>
                                <FormControl fullWidth className={classes.formControl}>   
                                <TextField          
                                    variant="outlined"   
                                    InputLabelProps={{shrink: true}}  
                                    label={t('label.value')+" *"}                                                         
                                    name="valor"        
                                    inputRef={register({required: true})}  
                                    error={errors.valor?true:false}  
                                    defaultValue={''} 
                                    InputProps={{ inputComponent: MaskMoney }}  
                                />
                                {errors.valor &&<FormHelperText className={classes.labelRootError}>
                                     <span> {t('label.required')} </span>
                                </FormHelperText> }  
                                </FormControl>  
                            </GridItem>  
                            <GridItem xs={12} sm={12} md={12}> 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    error={errors.historico?true:false} 
                                    label={t('label.historic')+" *"} 
                                    variant="outlined"                                    
                                    inputRef={register({required: true})}
                                    name="historico"
                                    defaultValue={''}  
                                    InputLabelProps={{shrink: true}}   
                                    inputProps={{maxLength: 500}}                                          
                                    multiline
                                    rows={2}
                                    rowsMax={4}
                                />
                                {errors.historico &&<FormHelperText className={classes.labelRootError}>
                                     <span>{t('label.required')}</span>
                                </FormHelperText> }  
                                </FormControl>                                 
                            </GridItem> 
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl fullWidth className={classes.formControl}>  

                                <label className={errors.estabelecimentos?"select__label select__label_error":"select__label"}>
                                    {t('label.establishments')}  </label>
                                <Select  
                                    isDisabled={isDisabledEstabelecimento}                              
                                    styles={ValidSelect(errors.estabelecimentos?true:false)} 
                                    classNamePrefix="select"  
                                    isSearchable={true}
                                    placeholder="Selecione..."
                                    isMulti={true}    
                                    name="estabelecimentos"                                  
                                    isLoading={loadingSelectEstabelecimentos}
                                    options={listSelectEstabelecimentos}     
                                    getOptionLabel={({descricao, ativo }) => descricao + " - " + (ativo == true ? 'ATIVO' : 'INATIVO')}
                                    getOptionValue={({estabelecimentoId}) => estabelecimentoId} 
                                    value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1 )}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}   
                                    ref={() => register(
                                        { name: "estabelecimentos" },
                                        { required: true  })
                                    }
                                />
                                {errors.estabelecimentos && <FormHelperText className={classes.labelRootError}>
                                    <span> {t('label.required')} </span>
                                </FormHelperText> }
                                {!isDisabledEstabelecimento &&
                                    <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                        {t('label.select_all_establishments')} 
                                </a> }  
                                </FormControl> 
                            </GridItem>   
                        </GridContainer>
                        <Clearfix />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                <br/>
                <div className={classes.textCenter}>
                    <Button  onClick={() => handleView()} color="transparent" className={classes.updateProfileButton}>
                        {t('button.cancel')} 
                    </Button>
                    <Button type="submit" color="primary" className={classes.updateProfileButton}>
                        {t('button.to_save')}  
                        {loading && <div> ... {t('label.loading')}</div>}
                    </Button>
                </div>
            </GridItem>
        </GridContainer>            
        </form>
        
        <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification(false)}
        close
        />
    </div>
);
}